import i18n from 'Lib/i18n'
export interface PaidMarketingOption {
  title: string
  url: string
  unallowedAccess?: boolean
}

export const PAID_MARKETING_OPTIONS = ({
  owner,
  isAdmin,
}: {
  owner: boolean
  isAdmin: boolean
}): Array<PaidMarketingOption> => [
  {
    title: i18n.t('paid_marketing.dashboard', { ns: 'mainMenu' }),
    url: 'paid-marketing/dashboard',
  },
  {
    title: i18n.t('paid_marketing.detailed_view', { ns: 'mainMenu' }),
    url: 'paid-marketing/domain/detailed-view',
  },
  {
    title: i18n.t('paid_marketing.platform_connection', { ns: 'mainMenu' }),
    url: 'paid-marketing/platforms',
    unallowedAccess: !owner && !isAdmin,
  },
  {
    title: i18n.t('paid_marketing.detection_settings', { ns: 'mainMenu' }),
    url: 'paid-marketing/detection-settings',
    unallowedAccess: !owner && !isAdmin,
  },
]
